import type { Role, Severity } from '../../Services/agents';

// Helpers purs de l'organisation : arbre depuis les liens parent/enfant, libellés.

export interface OrgNode<T extends { role: Role }> {
	item: T;
	children: OrgNode<T>[];
}

// #region buildTree
// buildTree reconstruit l'organigramme (ordre du registre conservé) à partir du
// champ `parent` de chaque rôle. Un rôle dont le parent est inconnu remonte à la racine.
export const buildTree = <T extends { role: Role }>(items: T[]): OrgNode<T>[] => {
	const nodes = new Map<string, OrgNode<T>>();
	items.forEach((item) => nodes.set(item.role.slug, { item, children: [] }));
	const roots: OrgNode<T>[] = [];
	items.forEach((item) => {
		const node = nodes.get(item.role.slug)!;
		const parent = item.role.parent ? nodes.get(item.role.parent) : undefined;
		if (parent) parent.children.push(node);
		else roots.push(node);
	});
	return roots;
};
// #endregion

// #region libellés
export const scheduleLabel = (s: Role['schedule']): string =>
	({ daily: 'Quotidien', weekly: 'Hebdomadaire', monthly: 'Mensuel' } as Record<string, string>)[s] || s;

export const kindLabel = (k: Role['kind']): string => (k === 'manager' ? 'Manager' : 'Spécialiste');

export const familyLabel = (f: string): string =>
	({
		advertiser: 'connecteur publicitaire',
		analytics: 'connecteur analytics',
		sales: 'connecteur métier',
		managed_dw: 'datawarehouse hébergé',
		data: 'au moins un connecteur',
	} as Record<string, string>)[f] || f;

export const severityColor = (s: Severity): 'info' | 'warning' | 'error' =>
	s === 'critical' ? 'error' : s === 'warning' ? 'warning' : 'info';
// #endregion
